/*
 * @Author: 吴文洁
 * @Date: 2019-09-06 09:51:29
 * @LastEditors: renmanyi
 * @LastEditTime: 2022-08-01 14:22:58
 * @Description:
 */
import User from '@/core/user';

class WechatRouter {
  router() {
    if (window.location.hash.indexOf('/wxPanelEntry/jump') > 0) {
      let array = window.location.hash.split('/');
      window.traceLog('C_HomeworkParents', 'C端推送消息', {
        href: window.location,
      });
      console.log('--------url--------', window.location.hash);
      let id = array[array.length - 1];
      if (id.indexOf('?') != -1) {
        id = id.split('?')[0];
      }
      const type = array[array.length - 2];
      if (type === 'OPENTM207433547') {
        const openId = User.openId();
        window.location.href = decodeURIComponent(id) + (openId ? (decodeURIComponent(id).indexOf('?') !== -1 ? '&' : '?') + 'openId=' + openId : '');
        return;
      } else if (type === 'LEAVE_APPLY_APPROVAL' || type === 'OPENTM410086222') {
        window.router.replace({
          name: 'leave_apply_detail',
          params: {
            id: id,
            wechat: true,
            type,
          },
        });
        return;
      } else if (type === 'LEAVE_APPLY_APPROVAL_V5') {
        window.router.replace({
          name: 'leave_apply_detail_v5',
          params: {
            id: id,
            wechat: true,
            type,
          },
        });
        return;
      }
      // setTimeout(() => {
      //   window.showLoading();
      // });
      switch (type) {
        // 余额
        case 'ACCOUNT_BALANCE_CHANGE':
          const [instId, userId] = id.split('-');

          window.router.replace({
            name: 'remainder_page',
            query: {
              instId,
            },
          });
          break;
        // 上课提醒
        case 'CLASS_START_NOTIFY':
        case 'OPENTM206931431':
          let paramArr = id.split('-');
          let scheduleId = paramArr[0];
          let startTime = paramArr[1];

          if (scheduleId) {
            window.router.replace({
              name: 'mine_course_schedule_detail_v5',
              query: {
                wechat: true,
                type,
                scheduleId,
                startTime,
              },
            });
          } else {
            window.router.replace({
              name: 'mine_course_schedule',
              query: {
                wechat: true,
                type,
              },
            });
          }
          break;
        //  上课提醒通知
        case 'CLASS_START_STUDENT':
          let _paramArr = id.split('-');
          let _scheduleId = _paramArr[0];
          let _startTime = _paramArr[1];
          let _targetId = _paramArr[2]

          if (_scheduleId) {
            window.router.replace({
              name: 'mine_course_schedule_detail_v5',
              query: {
                wechat: true,
                type,
                scheduleId:_scheduleId,
                startTime:_startTime,
                targetId:_targetId
              },
            });
          } else {
            window.router.replace({
              name: 'mine_course_schedule',
              query: {
                wechat: true,
                type,
              },
            });
          }
          break;
        // 小麦粒积分
        case 'TASK_COMPLETE':
        case 'OPENTM411436762':
          let paramList = id.split('-');
          let studentId = paramList[1];
          window.router.replace({
            name: 'mine_points',
            query: {
              studentId,
              wechat: true,
              type,
            },
          });
          break;
        // 作业
        case 'C_HOMEWORK':
        case 'OPENTM405774022':
        case 'C_HOMEWORK_SUBMIT':
        case 'OPENTM406772653':
        case 'STUDENT_HOMEWORK':
        case 'HOMEWORK_NOT_SUBMIT':
          paramList = id.split('-');
          let homeworkId = paramList[0];
          studentId = paramList[1];
          let messageId = paramList[2];
          window.traceLog('C_HomeworkReading', 'C端课后作业阅读量');
          window.traceLog('C_HomeworkViews', 'C端课后作业浏览量');
          window.router.replace({
            name: 'home_work_detail',
            query: {
              id: homeworkId,
              studentId: studentId,
              messageId,
              wechat: true,
              type,
            },
          });

          break;

        case 'EXAM_HOMEWORK': // 测评作业详情
        case 'EXAM_HOMEWORK_NOT_SUBMIT': // 测评作业未提交
          paramList = id.split('-');
          homeworkId = paramList[0];
          studentId = paramList[1];
          messageId = paramList[2];
          window.traceLog('C_HomeworkReading', 'C端课后作业阅读量');
          window.traceLog('C_HomeworkViews', 'C端课后作业浏览量');
          window.router.replace({
            name: 'exam_home_work_detail',
            query: {
              id: homeworkId,
              studentId: studentId,
              messageId,
              wechat: true,
              type,
            },
          });
          break;

        // 课后点评提醒
        case 'CLASS_REMARK_NOTIFY':
        case 'CLASS_EVALUATE':
        case 'OPENTM206165018':
          paramList = id.split('-');
          let _id = paramList[0];
          messageId = paramList[1];
          window.traceLog('C_CommentReading', 'C端课后点评阅读量');
          window.traceLog('C_CommentViews', 'C端课后点评浏览量');
          window.router.replace({
            name: 'comment_detail',
            query: {
              id: _id,
              messageId,
              wechat: true,
              type,
            },
          });
          break;
        case 'C_INST_MESSAGE':
        case 'SCHOOL_MESSAGE':
        case 'OPENTM207375252':
          paramList = id.split('-');
          _id = paramList[0];
          messageId = paramList[1];
          window.router.replace({
            name: 'institution_message_detail',
            query: {
              id: _id,
              messageId,
              wechat: true,
              type,
            },
          });
          break;
        case 'REVERT_MESSAGE_EXAM_HOMEWORK':
          paramList = id.split('-');
          homeworkId = paramList[1];
          studentId = paramList[2];
          messageId = paramList[paramList.length - 1];
          window.router.replace({
            name: 'exam_home_work_detail',
            query: {
              id: homeworkId,
              studentId: studentId,
              messageId,
              wechat: true,
              type,
            },
          });
          break;
        case 'REVERT_MESSAGE_NOTIFY':
        case 'REVERT_MESSAGE_GROWTH':
        case 'REVERT_STUDENT_MESSAGE':
        case 'REVERT_MESSAGE_HOMEWORK':
        case 'OPENTM211120410':
          let idList = id.split('-');
          if (idList[0] === 'HOME_WORK') {
            let homeworkId = idList[1];
            let studentId = idList[2];
            messageId = idList[idList.length - 1];
            window.router.replace({
              name: 'home_work_detail',
              query: {
                id: homeworkId,
                studentId: studentId,
                messageId,
                wechat: true,
                type,
              },
            });
          } else if (idList[0] === 'STUDENT_EVALUATION') {
            let id = idList[1];
            // let studId = idList[2];
            messageId = idList[idList.length - 1];
            window.router.replace({
              name: 'comment_detail',
              query: {
                id: id,
                messageId,
                wechat: true,
                type,
                // studentId: studId
              },
            });
          } else {
            let id = idList[1];
            let stdId = idList[2];
            messageId = idList[idList.length - 1];
            window.router.replace({
              name: 'mine_archives_detail',
              query: {
                id: id,
                studentId: stdId,
                messageId,
                wechat: true,
                type,
              },
            });
          }
          break;

        // 新增成长档案
        case 'C_GROWTH_ARCHIVES':
        case 'GROWTH_ARCHIVES':
        case 'OPENTM413796404':
          let queryList = id.split('-');
          let arcId = queryList[0];
          let stuId = queryList[1];
          messageId = queryList[queryList.length - 1];
          window.traceLog('C_GrowthArthivesReading', 'C端成长档案阅读量');
          window.traceLog('C_GrowthArthivesViews', 'C端成长档案浏览量');
          window.router.replace({
            name: 'mine_archives_detail',
            query: {
              id: arcId,
              studentId: stuId,
              messageId,
              wechat: true,
              type,
            },
          });
          break;

        // 优惠券通知
        case 'SEND_COUPON':
        case 'COUPON_ACTIVITY':
        case 'OPENTM205702264':
          let url = window.location.origin + window.location.pathname + '?appid=' + User.appId() + '#/benefits/coupon_share/' + id;
          window.location.href = url;
          break;

        // 自动分发的优惠券，已领取成功
        case 'INST_SEND_COUPON':
          localStorage.setItem(`couponId-${id}`, id);
          window.location.href = window.location.origin + window.location.pathname + '?appid=' + User.appId() + '#/benefits/coupon_share/' + id;
          break;

        // 转介绍活动详情
        case 'ACTIVITY_NOTIFY':
        case 'REFERRAL_ACTIVITY':
        case 'SEND_REWARD':
          let href = window.location.origin + window.location.pathname + '?appid=' + User.appId() + '#/transfer/index/' + id;
          window.location.href = href;
          break;

        // 学员续费提醒
        case 'RENEW_COUPON':
        case 'OPENTM405714145':
          let newUrl = window.location.origin + window.location.pathname + '?appid=' + User.appId() + '#/benefits/coupon_share/' + id;
          window.location.href = newUrl;
          break;

        // 新增关联学员通知
        // case 'RENEW_COUPON':
        case 'OPENTM666':
          window.router.replace({
            name: 'add_student',
            query: {
              wechat: true,
              type,
            },
          });
          break;

        // 成绩单详情
        case 'EXAM_MESSAGE':
          paramList = id.split('-');
          _id = paramList[0];
          messageId = paramList[1];
          window.router.replace({
            name: 'transcript_detail',
            query: {
              id: _id,
              messageId,
              type,
              wechat: true,
            },
          });
          break;
        case 'SCORE_EXCHANGE':
          window.router.replace({
            name: 'mine_points_exchange_record_detail',
            query: {
              type,
              orderId: id,
              wechat: true,
            },
          });
          break;
        case 'CHECK_OUT':
          window.router.replace({
            name: 'student_attdence',
            query: {
              id: id,
              wechat: true,
            },
          });
          break;
        case 'CHECK_IN':
          window.router.replace({
            name: 'student_attdence',
            query: {
              id: id,
              wechat: true,
            },
          });
          break;
        case 'ELECTRON_ALBUM':
          paramList = id.split('-');
          _id = paramList[0];
          messageId = paramList[1];
          window.router.replace({
            name: 'album_detail',
            query: {
              id: _id,
              messageId,
              wechat: true,
            },
          });
          break;
        case 'LIVE_NOTIFY': // 直播课堂
          paramList = id.split('-');
          const liveCourseId = paramList[0];
          studentId = paramList[1];
          const _instId = paramList[2];
          window.router.replace({
            name: 'live_detail',
            query: {
              id: liveCourseId,
              studentId,
              instId: _instId,
            },
          });
          break;
        case 'ORDER_VOUCHER': // 订单详情
          paramList = id.split('-');
          const voucherId = paramList[0];
          window.router.replace({
            name: 'voucher_detail',
            query: {
              voucherId: voucherId,
            },
          });
          break;
        case 'CORRECT_HOMEWORK': // 批改作业
          paramList = id.split('-');
          const correctId = paramList[0];
          window.router.replace({
            name: 'home_work_correct',
            query: {
              correctId,
            },
          });
          break;
        case 'CLOCK_STUDENT_HOMEWORK':
          urlParams = id.split('-');
          let csoure = urlParams[0];
          let hid = urlParams[1];
          let tkid = urlParams[2];
          let stId = urlParams[3];
          let xcxappid = urlParams[5];
          window.router.replace({
            name: 'punch',
            query: {
              clockWechatMpSourceEnum: csoure,
              homeworkId: hid,
              taskId: tkid,
              studentId: stId,
              appId: xcxappid,
            },
          });
          break;
        case 'CLOCK_HOMEWORK_NOT_SUBMIT':
          urlParams = id.split('-');
          let csoure_no = urlParams[0];
          let home_id = urlParams[1];
          let taskid = urlParams[2];
          let stuid = urlParams[3];
          let appid = urlParams[4];
          window.router.replace({
            name: 'punch',
            query: {
              clockWechatMpSourceEnum: csoure_no,
              homeworkId: home_id,
              taskId: taskid,
              studentId: stuid,
              appId: appid,
            },
          });
          break;
        case 'CLOCK_CORRECT_HOMEWORK': //打卡批改
          urlParams = id.split('-');
          let csoure_crrect = urlParams[0];
          let anId = urlParams[1];
          let teachId = urlParams[2];
          window.router.replace({
            name: 'punch',
            query: {
              clockWechatMpSourceEnum: csoure_crrect,
              answerId: anId,
              teacherId: teachId,
            },
          });
          break;
        case 'CLOCK_REVERT_MESSAGE_HOMEWORK':
          urlParams = id.split('-');
          let csoure_mess = urlParams[0];
          let homeowrk_id = urlParams[1];
          let stu_id = urlParams[2];
          let tId = urlParams[3];
          let ansId = urlParams[4];
          let appxm_id = urlParams[6];
          window.router.replace({
            name: 'punch',
            query: {
              clockWechatMpSourceEnum: csoure_mess,
              homeworkId: homeowrk_id,
              studentId: stu_id,
              taskId: tId,
              answerId: ansId,
              appId: appxm_id,
            },
          });
          break;
        case 'LIVE_COURSE_REPORT':
          urlParams = id.split('-');
          let courseId = urlParams[0];
          studentId = urlParams[1];
          window.router.replace({
            name: 'live_report',
            query: {
              liveCourseId: courseId,
              studentId,
            },
          });
          break;
        case 'CLASS_REPORT':
          urlParams = id.split('-');
          console.log(urlParams);
          courseId = urlParams[0];
          studentId = urlParams[1];
          window.router.replace({
            name: 'live_cloud-class-report',
            query: {
              courseId,
              studentId,
            },
          });
          break;
        case 'C_CROSS_INST_ORDER_FINISH': // 转校详情
          window.router.replace({
            name: 'transfer_school_detail',
            query: {
              id,
            },
          });
          break;
        default:
          Vue.$wheatToast({
            message: '暂不支持此消息类型',
            position: 'middle',
          });
          break;
      }
    }
  }
}

export default new WechatRouter();



// WEBPACK FOOTER //
// ./src/router/WechatRouter.js